import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { $recipientByIdStore } from '@lib/store';
import { RoutePaths } from '@shared/utils';
import { TransferRecipientTypeEnum } from '@shared/api/rest/recipients';
import { RecipientTransaction } from './recipientTransaction';
import { RecipientsDetails } from './recipientDetails';
import { ColorsEnum, Icon, PageContainer, Spinner, Text } from '@shared/widgets';
import ArrowIcon from '@assets/icons/arrow.svg';

export const RecipientItem = () => {
  const { id } = useParams();

  const recipientGetById = useUnit($recipientByIdStore.store);

  useEffect(() => {
    if (!id) return;
    $recipientByIdStore.events.getById(id);
  }, [id]);

  return (
    <PageContainer
      title='Payments'
      header={
        <div className='flex gap-2 items-center'>
          <Link to={RoutePaths.payments.onNavigate()}>
            <Icon icon={<ArrowIcon />} className='rotate-180' />
          </Link>
          <Text weight='semibold' size='2xl'>
            Payments
          </Text>
        </div>
      }
    >
      <section className='flex items-stretch gap-6'>
        <main className='flex-1 min-w-64'>
          {recipientGetById.loading && <Spinner />}
          {!recipientGetById.loading && recipientGetById.data && (
            <div className='flex flex-col gap-6'>
              <div className='flex gap-2 bg-white dark:bg-soft-black p-4 mb-8'>
                {recipientGetById.data?.type === TransferRecipientTypeEnum.Individual ? (
                  <div className='w-12 h-12 bg-black flex items-center justify-center'>
                    <Text weight='semibold' color={ColorsEnum.White} size='xl'>
                      {!!recipientGetById.data?.firstName?.length && recipientGetById.data.firstName[0].toUpperCase()}
                    </Text>
                  </div>
                ) : (
                  <div className='w-12 h-12 bg-black flex items-center justify-center'>
                    <Text weight='semibold' color={ColorsEnum.White} size='xl'>
                      {!!recipientGetById.data?.companyName?.length &&
                        recipientGetById.data.companyName
                          .trim()
                          .split(' ')
                          .map((word) => (word?.[0] || '').toUpperCase())
                          .join('')}
                    </Text>
                  </div>
                )}
                <div>
                  {recipientGetById.data?.type === TransferRecipientTypeEnum.Individual && (
                    <Text weight='semibold' size='xl'>
                      {recipientGetById.data?.firstName} {recipientGetById.data?.lastName}
                    </Text>
                  )}
                  {recipientGetById.data?.type === TransferRecipientTypeEnum.Business && (
                    <Text weight='semibold' size='xl'>
                      {recipientGetById.data?.companyName}
                    </Text>
                  )}
                  <Text weight='semibold' size='xs' color={ColorsEnum.Gray} isUppercase>
                    {recipientGetById.data?.iban || recipientGetById.data?.accountNumber}
                  </Text>
                </div>
              </div>
            </div>
          )}
          {recipientGetById.data && (
            <div className='flex flex-col gap-6'>
              <Text weight='semibold' size='2xl'>
                Transaction
              </Text>
              <RecipientTransaction data={recipientGetById.data} />
            </div>
          )}
        </main>
        {recipientGetById.data && (
          <aside className='flex-none basis-[27%] grow-0 min-w-64'>
            {recipientGetById.loading && <Spinner />}
            {!recipientGetById.loading && <RecipientsDetails data={recipientGetById.data} id={id!} />}
          </aside>
        )}
      </section>
    </PageContainer>
  );
};
